import * as React from 'react'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useQueryCountries } from '@/modules/shared/query-client/useQueryCountries'
import { CountryModel } from '@/modules/shared/types/country'
import { useChartT } from '../i18n'

export function ChartCountryDialog({
  companyId,
  title,
  value,
  onConfirm,
  onCancel,
}: {
  companyId: string
  title: string
  value: number | null
  onConfirm: (country: CountryModel) => void
  onCancel: () => void
}) {
  const T = useChartT()
  const countries = useQueryCountries({ companyId })
  const [selected, setSelected] = React.useState(value)
  const country = countries.data?.find((c) => c.nationId === selected)
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      className="tw-fixed tw-inset-0 tw-z-[10001] tw-flex tw-items-center tw-justify-center tw-bg-black/50"
      onMouseDown={onCancel}
    >
      <form
        className="tw-w-[420px] tw-rounded-lg tw-bg-white tw-p-5 tw-shadow-xl"
        onMouseDown={(e) => e.stopPropagation()}
        onSubmit={(e) => {
          e.preventDefault()
          if (country) onConfirm(country)
        }}
      >
        <h3 className="tw-mb-4 tw-text-lg tw-font-semibold">{title}</h3>
        <FieldsetSelect
          menuZIndex={10002}
          label={T('country', 'Kraj')}
          placeholder={T('selectCountry', 'Wybierz kraj')}
          searchEnabled
          value={selected?.toString() ?? ''}
          disabled={countries.isLoading || countries.isError}
          options={(countries.data ?? []).map((c) => ({
            value: c.nationId.toString(),
            label: c.name,
          }))}
          onChange={(e) => setSelected(Number(e.target.value))}
        />
        {countries.isError && (
          <p role="alert">
            {T('countriesLoadFailed', 'Nie udało się pobrać krajów.')}{' '}
            <button type="button" onClick={() => countries.refetch()}>
              {T('retry', 'Ponów')}
            </button>
          </p>
        )}
        <div className="tw-mt-5 tw-flex tw-justify-end tw-gap-2">
          <button type="button" className="tw-rounded tw-border tw-border-base-300 tw-px-3 tw-py-2 tw-text-sm" onClick={onCancel}>
            {T('cancel', 'Anuluj')}
          </button>
          <button
            type="submit"
            className="tw-rounded tw-bg-primary tw-px-3 tw-py-2 tw-text-sm tw-text-white disabled:tw-opacity-40"
            disabled={!country}
          >
            {T('confirm', 'Zatwierdź')}
          </button>
        </div>
      </form>
    </div>
  )
}
